import { css, SerializedStyles } from "@emotion/react";

export default {
  imageContainer(width: number): SerializedStyles {
    return css`
      width: ${width}%;
      display: block;
      border: none;
      margin-top: 2rem;
      margin-bottom: 2rem;
    `;
  },
  imageComponent: css`
    width: 100%;
    height: 100%;
  `,
};
